import { ChevronDown } from 'lucide-react'
import { useState, useCallback } from 'react'

import { BulkActionsModal } from './BulkActionsModal'
import { AllFiltersArea } from '@components/Filters/filter.types'
import { Button, MarqueeText } from '@fp/ui-kit'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@ui/DropDownMenu'

type BulkAction = {
  action_name: string
  name: string
  method: string
  path: string
  applicability?: boolean
}

interface BulkActionsMenuProps {
  bulkActions: BulkAction[]
  filterArea: AllFiltersArea
  selectedIds: Record<string | number, boolean>
}

export const BulkActionsMenu = ({ bulkActions, filterArea, selectedIds }: BulkActionsMenuProps) => {
  const [selectedAction, setSelectedAction] = useState<BulkAction | null>(null)
  const [modalOpen, setModalOpen] = useState(false)

  const handleSelect = useCallback((action: BulkAction) => {
    setSelectedAction(action)
    setModalOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setSelectedAction(null)
    setModalOpen(false)
  }, [])

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant='outline' className='min-w-65'>
            <div className='flex justify-between w-full'>
              Bulk Actions <ChevronDown />
            </div>
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align='start' className='w-(--radix-popper-anchor-width) space-y-1'>
          {bulkActions.map((action) => (
            <DropdownMenuItem
              key={action.action_name}
              onSelect={() => handleSelect(action)}
              textValue={action.name?.replaceAll(' ', '_')}
              className='w-full border border-muted'
            >
              <MarqueeText className='w-full'>{action.name}</MarqueeText>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      {selectedAction && (
        <BulkActionsModal
          open={modalOpen}
          onClose={handleClose}
          action={selectedAction}
          tabKey={filterArea}
          selectedIds={selectedIds}
        />
      )}
    </>
  )
}
